import type { Variant } from 'framer-motion';
import { AnimatePresence, motion } from 'framer-motion';
import type { FC, ReactNode } from 'react';

interface OpacitySlideInProps {
  children: ReactNode;
  className?: string;
  slideFrom: { y: number | string; x: number | string };
  slideTo?: { y: number | string; x: number | string }; // Defaults to 0
  duration?: number; // Defaults to 0.8 seconds
  animateMultiple?: boolean;
  delay?: number;
  threshold?: number;
}

const OpacitySlideIn: FC<OpacitySlideInProps> = ({
  children,
  className,
  slideFrom,
  slideTo = { x: 0, y: 0 },
  duration = 0.5,
  animateMultiple,
  delay = 0,
  threshold = 0.5,
}) => {
  const variants: Record<string, Variant> = {
    initial: { opacity: 0, y: slideFrom.y, x: slideFrom.x },
    visible: { opacity: 1, y: slideTo.y, x: slideTo.x },
  };

  return (
    <AnimatePresence mode="sync">
      <motion.div
        className={className}
        initial="initial"
        transition={{ duration, delay, ease: 'easeInOut' }}
        variants={variants}
        viewport={{ once: !animateMultiple, amount: threshold }}
        whileInView="visible"
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
};

export default OpacitySlideIn;
